import { fade, makeStyles } from "@material-ui/core";
import { grey } from "@material-ui/core/colors";

export default makeStyles((theme) => ({
  statusRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    width: "100%",
    marginTop: theme.spacing(1),
  },
  statusSwitch: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled": {
      color: theme.palette.primary.main,
    },
    "& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": {
      backgroundColor: theme.palette.primary.main,
      opacity: 0.5,
    },
  },
  statusLabel: {
    color: theme.palette.primary.main,
    fontSize: 12,
    letterSpacing: 1.2,
    textTransform: "uppercase",
  },
  statusLabelOff: {
    color: grey[600],
  },
  sinceChip: {
    backgroundColor: fade(theme.palette.primary.main, 0.08),
    color: theme.palette.primary.main,
    "& .MuiChip-icon": {
      color: theme.palette.primary.main,
    },
  },
  subtitle: {
    color: grey[700],
    fontSize: 14,
  },
  methodRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    width: "100%",
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    backgroundColor: grey[50],
    cursor: "pointer",
    transition: theme.transitions.create("background-color"),
    "&:hover": {
      backgroundColor: grey[100],
    },
    justifyContent: "space-between",
  },
  iconBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0,
    width: 40,
    height: 40,
    borderRadius: theme.spacing(1),
    backgroundColor: fade(theme.palette.primary.main, 0.08),
  },
  methodContent: {
    flex: 1,
    minWidth: 0,
  },
  methodTitle: {
    color: theme.palette.common.black,
    fontSize: 16,
  },
  methodChip: {
    backgroundColor: fade(theme.palette.primary.main, 0.08),
    color: theme.palette.primary.main,
    "& .MuiChip-icon": {
      color: theme.palette.primary.main,
    },
  },
  arrowIcon: {
    color: theme.palette.primary.main,
  },
  divider: {
    width: "100%",
    margin: theme.spacing(1, 0),
  },
  preferredControl: {
    marginBottom: theme.spacing(1),
  },
  trustedDevicesCard: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    width: "100%",
    padding: theme.spacing(1.5),
    borderRadius: theme.spacing(1),
    backgroundColor: grey[50],
    textAlign: "left",
    cursor: "pointer",
    transition: theme.transitions.create("background-color"),
    "&:hover": {
      backgroundColor: grey[100],
    },
  },
  trustedDevicesContent: {
    flex: 1,
    minWidth: 0,
    display: "flex",
    flexDirection: "column",
    gap: theme.spacing(0.5),
  },
  trustedDevicesTitle: {
    color: theme.palette.common.black,
    fontSize: 18,
    fontWeight: 500,
  },
  trustedDevicesSubtitleRow: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(0.5),
  },
  trustedDevicesSubtitle: {
    color: theme.palette.common.black,
    fontSize: 14,
  },
  trustedDevicesIcon: {
    color: theme.palette.primary.main,
  },
}));
